/// <reference path="./types.js" />
import { useEffect } from "react";
import { count } from "./functions/count";
import { recursionCritical } from "./functions/recursionCritical";
import { newTry } from "./functions/newTry";
import {
  colorizeEdges,
  colorizeNodes,
  descolorizeEdges,
  descolorizeNodes,
} from "./functions/colorize";

/**
 * Prepara os elementos do fluxo, clonando e zerando o criticalPath.
 */
function prepareElements(flow) {
  return flow.map((item) => ({
    ...JSON.parse(JSON.stringify(item)),
    data: { ...item.data, criticalPath: false },
  }));
}

/**
 * Marca elementos críticos com base nas stats calculadas.
 */
function markCriticalElements(elements, stats) {
  elements.forEach((el) => {
    const isCritical =
      stats.some((item) => item.taskId === el.id) ||
      (el.source &&
        stats.some(
          (item) => item.taskId === el.source || item.taskId === el.target
        ));
    if (isCritical) el.data.criticalPath = true;
  });
  return elements;
}

/**
 * Aplica recursionCritical e newTry para retornar elementos críticos finais.
 */
function getCriticalPathElements(elements, startId) {
  const newElements = recursionCritical(startId, elements);
  const nextElements = newTry(newElements);
  return nextElements
    .filter((item) => item.data.criticalPath)
    .map((el) => ({
      id: el.id,
      data: el.data,
      type: el.type,
    }));
}

/**
 * Calcula o tempo total do caminho crítico.
 */
function getCriticalTime(stats) {
  return stats.reduce((sum, item) => sum + item.time, 0);
}

/**
 * Atualiza a visualização (coloriza ou descoloriza) dos elementos.
 */
function updateVisualization(nodes, edges, criticalPath, undoFlow, critical) {
  if (critical) {
    colorizeNodes(nodes, criticalPath);
    colorizeEdges(edges, criticalPath);
  } else {
    descolorizeNodes(nodes, undoFlow);
    descolorizeEdges(edges, undoFlow);
  }
}

/**
 * Hook para ativar o caminho crítico no fluxo.
 */
const useActiveCriticalPath = (critical, undoFlow = [], setStats) => {
  useEffect(() => {
    const nodes = document.getElementsByClassName("flow_elements_node");
    const edges = document.getElementsByClassName("flow_elements_edge");

    if (!nodes) return;

    if (critical) {
      const eventStart = undoFlow?.find((e) => e.type === "eventStart");
      if (!eventStart) return;

      const { stats } = count(undoFlow, eventStart);
      let elements = prepareElements(undoFlow);
      elements = markCriticalElements(elements, stats);
      elements.sort((a, b) =>
        a.data.criticalPath && !b.data.criticalPath ? 1 : -1
      );

      const criticalPathElements = getCriticalPathElements(
        elements,
        eventStart.id
      );

      const criticalTime = getCriticalTime(stats);

      setStats(criticalTime);
      updateVisualization(nodes, edges, criticalPathElements, undoFlow, true);
    } else {
      updateVisualization(nodes, edges, [], undoFlow, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [critical]);
};

export default useActiveCriticalPath;
